import { LoadingAnimation } from "src/components/main/subcomponents/LoadingAnimation";

export const Loading = ({ isLoading }) => {
  return isLoading ? <LoadingAnimation /> : null;
};
